import { useEffect, useState, useRef, useCallback } from "react";
import { getItem, onChangeEvent, cancel as cancelRequest } from "../actions/requestsActions";
import { usePersistentState } from './usePersistentState'
import useApi from "./useApi";
import { usePerson } from "../context/person";

export const useRequests = (hotelId, roomOccupationId, checkInId) => {
    const { get, post, put, patch } = useApi();
    const [loading, setLoading] = useState(false);
    const [items, setItems] = usePersistentState('requests', null)
    const [itemLoading, setItemLoading] = useState(false)
    const [item, setItem, _, getCurrentValueFromStore] = usePersistentState('request', null)
    const [error, setError] = useState(null)
    const [requestedCart, setRequestedCart] = usePersistentState('requestedCart', null)
    const { setData: setPersonData, setUpdateData } = usePerson();
    const onRequestsChangeSubscription = useRef(null)

    useEffect(() => {
        setItems(null);
        setItem(null);
        if (!checkInId) return
        // onSomeRequestRoomOccupationChange
        if (onRequestsChangeSubscription.current?.checkInId && checkInId !== onRequestsChangeSubscription.current?.checkInId) {
            onRequestsChangeSubscription.current.subscription.unsubscribe()
            onRequestsChangeSubscription.current = null;
        }
        if (!onRequestsChangeSubscription.current) {
            onRequestsChangeSubscription.current = {
                checkInId: checkInId,
                subscription: onChangeEvent(checkInId, r => {
                    if (checkInId === onRequestsChangeSubscription.current.checkInId) {
                        const itemStored = getCurrentValueFromStore();
                        if (itemStored?.id === r.id) {
                            loadItem(r.id);
                        }
                        loadItems();
                    }
                })
            }
        }
        // if (!onRequestChangeSubscription.current && checkInId) {
        // onRequestChangeSubscription.current = onChangeEvent(checkInId, r => {
        //     console.log('17sep - &&&&&& onChangeEvent - r', r);
        //     const itemStored = getCurrentValueFromStore();
        //     if (itemStored?.id === r.id) {
        //         loadItem(r.id);
        //     }
        //     loadItems()
        //     // if (data.status !== r.status) {
        //     //     setData({ ...data, status: r.status })
        //     // }
        //     // if (data.roomOccupationId !== r.roomOccupationId) {
        //     //     console.log('status setting roomOccupationID', r.roomOccupationId)
        //     //     setData({ ...data, roomOccupationId: r.roomOccupationId })
        //     // }
        //     // refreshStatus();
        // })
        // }

        return () => {
            if (onRequestsChangeSubscription?.current) {
                try {
                    if (onRequestsChangeSubscription.current?.subscription?.unsubscribe) {
                        onRequestsChangeSubscription.current.subscription.unsubscribe();
                    }
                } finally {
                    onRequestsChangeSubscription.current = null;
                }
            }
        }

    }, [checkInId])

    // useEffect(() => {
    //     // console.log('AAA [] onCheckInChangeSubscription.current', onCheckInChangeSubscription.current)
    //     // console.log('AAA [] data', data)
    //     // return () => {
    //     //     console.log('AAA [] unsubscribe', onCheckInChangeSubscription.current)
    //     //     if (onCheckInChangeSubscription.current) {
    //     //         console.log('AAA [] unsubscribe 123456')
    //     //         try {
    //     //             if (onCheckInChangeSubscription.current?.unsuscribe) {
    //     //                 onCheckInChangeSubscription.current?.unsuscribe();
    //     //             }
    //     //         } finally {
    //     //             onCheckInChangeSubscription.current = null;
    //     //         }
    //     //     }
    //     // }
    // }, [])

    useEffect(() => {
        if (items === null && checkInId) {
            setLoading(true)
            loadItems()
        }
    }, [checkInId])


    const loadItems = async () => {
        try {
            setLoading(true);
            const response = await get(`hotels/${hotelId}/checkins/${checkInId}/requests`);
            if (response) {
                setItems(response);
            } else {
                console.error('Error on load items.');
            }
        } catch (error) {
            console.error('Error on load items:', error);
        } finally {
            setLoading(false);
        }
    };

    const loadItem = async (id) => {
        try {
            setItemLoading(true);
            const response = await get(`hotels/${hotelId}/checkins/${checkInId}/requests/${id}`);
            if (response) {
                setRequestedCart(response.cart)
                setItem(response);
            } else {
                console.error('Error on load item.');
            }
        } catch (error) {
            console.error('Error on load item:', error);
        } finally {
            setItemLoading(false);
        }
    };




    const clear = () => {
        setItems(null)
    }

    const addComment = async (id, comment) => {
        console.log('18ago - comment', comment)
        console.log('18ago - hotelId', hotelId)
        console.log('18ago - checkInId', checkInId)
        console.log('18ago - id', id)
        try {
            setLoading(true);
            const response = await post(`hotels/${hotelId}/checkins/${checkInId}/requests/${id}/comments`, {
                "comment": comment
            });
            console.log('18ago - response', response)
            if (response) {
                if (id === item?.id) {
                    setItem({ ...item, showNotification: 0 })
                }
                if (items) {
                    setItems(items.map(r => r.id === id ? { ...r, showNotification: 0 } : r))
                }
                console.log('Request created successfully:', response);
            } else {
                console.error('Error creating request.');
            }
        } catch (error) {
            console.error('Error comment request:', error);
        } finally {
            setLoading(false);
        }


        // return addCommentAction(id, hotelId, roomOccupationId, comment)
        //     .then(r => {
        //         if (id === item?.id) {
        //             loadItem(id);
        //         }
        //         return r;
        //     })
        // .finally(() => setSendingComment(false))
    }

    const loadRequestedCart = (cart) => {  // Hacerlo en otro lado para tener mas contexto y no tanto parametro
        setRequestedCart(cart);
    }

    const cancel = async (id) => {
        try {
            setLoading(true);
            const response = await patch(`hotels/${hotelId}/checkins/${checkInId}/requests/${id}`);
            if (response) {
                if (id === item?.id) {
                    setItem({ ...item, status: 'canceled' })
                }
                if (items) {
                    setItems(items.map(r => r.id === id ? { ...r, status: 'canceled' } : r))
                }
                console.log('Request created successfully:', response);
            } else {
                console.error('Error creating request.');
            }
        } catch (error) {
            console.error('Error creating request:', error);
        } finally {
            setLoading(false);
        }
    }

    const createRequest = async (payload) => {
        let response = null
        try {
            setLoading(true);
            if (payload.id) {
                if (checkInId) {
                    response = await put(`hotels/${hotelId}/checkins/${checkInId}/requests/${payload.id}`, payload);
                } else {
                    response = await put(`hotels/${hotelId}/stays/${roomOccupationId}/requests/${payload.id}`, payload);
                }
            } else {
                console.log('19dic - payload', payload)

                if (checkInId) {
                    console.log('19dic - post checkins')
                    response = await post(`hotels/${hotelId}/checkins/${checkInId}/requests`, payload);
                } else if (roomOccupationId) {
                    console.log('19dic - post stay')
                    response = await post(`hotels/${hotelId}/stays/${roomOccupationId}/requests`, payload);
                } else {
                    console.log('19dic - post public')
                    response = await post(`hotels/${hotelId}/public/requests`, payload);
                    if (response?.token) {
                        localStorage.setItem('ViCo::token-' + hotelId + '-person', response.token);
                    }
                    if(response?.person) {
                        setUpdateData({...response.person});
                    }
                }
            }
            if (response) {
                console.log('Request called successfully:', response);
            } else {
                console.error('Error creating request.');
            }
        } catch (error) {
            console.error('Error creating request:', error);
        } finally {
            setLoading(false);
        }
        return response;
    };

    const createPublicRequest = async (payload) => {
        try {
            setLoading(true);
            let response = await post(`hotels/${hotelId}/bookables/reservation`, payload);
            if (response) {
                console.log('response', response);
                if (response.personId && response.token) {
                    setPersonData(response?.person ?? {})
                    localStorage.setItem('ViCo::token-' + hotelId + '-person', response.token);
                }
                console.log('Request called successfully:', response);
            } else {
                console.error('Error creating request.');
            }
        } catch (error) {
            console.error('Error creating request:', error);
        } finally {
            setLoading(false);
        }
    };

    const markAsReaded = async (id) => {
        try {
            setLoading(true);
            const response = await put(`hotels/${hotelId}/checkins/${checkInId}/requests/${id}/readed`);
            if (response) {
                if (id === item?.id) {
                    setItem({ ...item, showNotification: 0 })
                }
                if (items) {
                    setItems(items.map(r => r.id === id ? { ...r, showNotification: 0 } : r))
                }
                console.log('Request created successfully:', response);
            } else {
                console.error('Error creating request.');
            }
        } catch (error) {
            console.error('Error creating request:', error);
        } finally {
            setLoading(false);
        }
    };

    const createPromiseUpsellComment = useCallback(async (promiseKey, comment) => {
        let rOk = false;
        try {
            const rOk = await put(`hotels/${hotelId}/checkins/${checkInId}/requests_promises/${promiseKey}`, { comment });
            console.log('7oct rOk', rOk)
            if (rOk) {
                if (items) {
                    setItems(items.map(r => r.promiseKey === promiseKey ? { ...r, comment: comment } : r))
                }
            } else {
                console.error('Error creating request.');
            }
        } catch (error) {
            console.error('Error creating request:', error);
        }
        return rOk;
    }, [items]);


    return {
        loading,
        items,
        item,
        itemLoading,
        loadItems,
        loadItem,
        error,
        clear,
        addComment,
        cancel,
        createRequest,
        createPublicRequest,
        markAsReaded,
        requestedCart,
        createPromiseUpsellComment,
        loadRequestedCart
    }

}